import { defineComponent as _defineComponent } from 'vue'
import { ref, useRoute, onMounted, watch, computed } from '@nuxtjs/composition-api';
import Vue from 'vue';
import TInput from '~/components/atoms/t-input.vue';

interface Props {
  queryStringValue: string;
  labelText: string;
  dataRecurlyValue: string;
  error?: string | null;
}

interface Emits {
  (event: 'onApply', value: string | undefined): void;
  (event: 'resetError'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DiscountInput',
  props: {
    queryStringValue: null,
    labelText: null,
    dataRecurlyValue: null,
    error: null
  },
  emits: ["onApply", "resetError"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'onApply', value: string | undefined): void;
  (event: 'resetError'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  queryStringValue: string;
  labelText: string;
  dataRecurlyValue: string;
  error?: string | null;
};



const recurlyDiscount = ref<string | null>(null);
const discountValue = ref<string | null>(null);
const recurlyInput = ref<HTMLInputElement | null>(null);
const isOpen = ref(false);
const validationError = ref<string | null>(null);
const formError = computed(() => props.error || validationError.value);

const route = useRoute();

onMounted(() => {
  const queryParams = route.value.query;

  if (
    queryParams[props.queryStringValue] &&
    typeof queryParams[props.queryStringValue] === 'string'
  ) {
    discountValue.value = queryParams[props.queryStringValue] as string;
    apply();
    isOpen.value = true;
  }
});

const apply = async () => {
  const invalidChars = discountValue.value?.match(/[./\\]/);
  if (invalidChars) {
    validationError.value = `Invalid character: ${invalidChars[0]}`;
    return;
  }

  validationError.value = null;
  emit('resetError');
  recurlyDiscount.value = discountValue.value;

  await Vue.nextTick();
  recurlyInput.value?.dispatchEvent(new Event('change'));
  emit('onApply', discountValue.value ? discountValue.value : undefined);
};

const reset = async () => {
  discountValue.value = null;
  await apply();
};

const toggleOpen = () => {
  isOpen.value = !isOpen.value;
};

watch(discountValue, () => {
  if (!discountValue.value) {
    apply();
  }
});

return { __sfc: true,props, emit, recurlyDiscount, discountValue, recurlyInput, isOpen, validationError, formError, route, apply, reset, toggleOpen, TInput }
}

})